// extracted by mini-css-extract-plugin
export default {"newTagInput":"AddTagInput_newTagInput__M8soN"};